import preloader from '../../../assets/images/preloader.svg'

let Preloader = () => {
  return <div>
    <img src={preloader} alt="Preloader" />
  </div>
}

export default Preloader